import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink, withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';
import { sendRequest as sendTaskToggleChosenMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleChosenMarkForm';
import { sendRequest as sendTaskToggleHideMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleHideMarkForm';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';
import PopUpLink from '../../../Common/GlobalPopUps/PopUpLink';
import TaskGeoTargetState from '../../_common/CheckGeotargetAccess/TaskGeoTargetStateNew';

class TaskItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      showLoading: false
    };
  }

  render() {
    return (
      <article className="panel panel-default task task_detailed">
        <div className="panel-heading panel-inner-border-bottom">
          <div className="task-table">
            <div className="task-cell">
              <h2 className="h3 task-title" title={this.props.task.title}>
                <NavLink
                  to={`/earn-money/task-view/${this.props.task.id}`}
                  title={this.props.task.title}
                >
                  {this.props.task.title}
                </NavLink>
              </h2>
            </div>
            <div className="task-cell task-price">
              <div className="task-price-val">
                <span className="h3">{this.props.task.totalCostExecution}</span>{' '}
                ₽
              </div>
            </div>
          </div>
          <ul className="list-inline task-info">
            <li className="text-muted">
              {formatter.dateFormat3(this.props.task.createdAt)}
            </li>
            <li className="text-muted">ID{this.props.task.id}</li>
            <li title={`http://${this.props.task.taskDomain}`}>
              <a
                className="text-success text-underline"
                target="_blank"
                rel="noopener noreferrer"
                href={`http://${this.props.task.taskDomain}`}
              >
                {this.props.task.taskDomain}
              </a>
            </li>
            <li>
              <NavLink
                to={`/users/profile/${this.props.task.ownerId}/comments`}
                className="text-muted"
                title={this.props.task.title}
              >
                <div className="media media_inline-table">
                  <div className="media-left">
                    <img
                      alt=""
                      className="media-object avatar avatar-xxs"
                      src={this.props.task.ownerAvatarPath}
                    />
                  </div>
                  <div className="media-body media-middle">
                    <div
                      className="text-overflow text-overflow_sm"
                      title={this.props.task.ownerUserName}
                    >
                      {this.props.task.ownerUserName}
                    </div>
                  </div>
                </div>
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="panel-body">
          <div className="row offset_bottom offset_bottom_xs">
            <div className="col-xs-24 col-sm-12">
              <dl className="dl-options dl-options-sm dl-horizontal task-options-left">
                <dt title={t('Категория')}>{t('Категория')}:</dt>
                <dd>{this.props.task.taskTypeDesc}</dd>
                <dt title={t('Проверка')}>{t('Проверка')}:</dt>
                <dd>{this.props.task.checkTypeDesc}</dd>
                <dt title={t('Многоразовость')}>{t('Многоразовость')}:</dt>
                <dd>{this.props.task.executorExecutionIntervalDesc}</dd>
              </dl>
            </div>
            <div className="col-xs-24 col-sm-12">
              <dl className="dl-options dl-options-sm dl-horizontal task-options-right">
                <dt title={t('Таргетинг по времени')}>
                  {t('Таргетинг по времени')}:
                </dt>
                <dd>
                  {this.props.task.hasTimeTarget > 0 ? (
                    <PopUpLink
                      hashName="getTimeTarget"
                      hashParams={{ id: this.props.task.id }}
                    >
                      {t('<span class="text-success">Есть</span>, узнать')}
                    </PopUpLink>
                  ) : (
                    <React.Fragment>{t('Нет')}</React.Fragment>
                  )}
                </dd>
                <dt title={t('Геотаргетинг')}>{t('Геотаргетинг')}:</dt>
                <dd>
                  <TaskGeoTargetState
                    task_id={this.props.task.id}
                    has_geo_target={this.props.task.hasGeoTarget}
                  />
                </dd>
                <dt title={t('Время выполнения')}>{t('Время выполнения')}:</dt>
                <dd>{this.props.task.timePerformDesc}</dd>
              </dl>
            </div>
          </div>
        </div>
        <div className="panel-footer panel-inner-border-top">
          <div className="btn-toolbar">
            <div className="btn-group btn-group-sm pull-left">
              <div className="btn btn-default btn-view">
                <span
                  className="text-success"
                  data-container="body"
                  data-toggle="tooltip"
                  title={
                    this.props.task.tasksExecsStat.statuses[4].execStatusTitle
                  }
                >
                  {this.props.task.tasksExecsStat.statuses[4].execCountByStatus}
                </span>{' '}
                <span className="text-muted">•</span>{' '}
                <span
                  data-container="body"
                  data-toggle="tooltip"
                  title={
                    this.props.task.tasksExecsStat.statuses[2].execStatusTitle
                  }
                >
                  {this.props.task.tasksExecsStat.statuses[2].execCountByStatus}
                </span>{' '}
                <span className="text-muted">•</span>{' '}
                <span
                  className="text-danger"
                  data-container="body"
                  data-toggle="tooltip"
                  title={
                    this.props.task.tasksExecsStat.statuses[5].execStatusTitle
                  }
                >
                  {this.props.task.tasksExecsStat.statuses[5].execCountByStatus}
                </span>{' '}
              </div>
              <div className="btn btn-default btn-view">
                <span
                  data-container="body"
                  data-toggle="tooltip"
                  title={t('Положительные отзывы')}
                >
                  <i className="text-primary fa fa-thumbs-o-up" />{' '}
                  <span className="text-muted">
                    {this.props.task.taskCommentsStat.likes}
                  </span>{' '}
                </span>
                &nbsp;
                <span
                  data-container="body"
                  data-toggle="tooltip"
                  title={t('Отрицательные отзывы')}
                >
                  <i className="text-primary fa fa-thumbs-o-down" />{' '}
                  <span className="text-muted">
                    {this.props.task.taskCommentsStat.dislikes}
                  </span>{' '}
                </span>
              </div>
            </div>
            <Link
              to={`/earn-money/task-view/${this.props.task.id}`}
              className="btn btn-success btn-sm"
              type="button"
            >
              {t('Выполнить')}
            </Link>
            {this.props.task.markHide ? (
              <button
                id={this.state.markHideButtonId}
                className="btn btn-muted btn-sm"
                data-toggle="tooltip"
                type="button"
                title={`${this.props.task.markHide.buttonMessage}`}
                onClick={() => this.props.taskToggleHideMark()}
              >
                <i
                  className={`fa ${
                    this.props.task.markHide.marked ? 'fa-eye-slash' : 'fa-eye'
                  }`}
                />
              </button>
            ) : null}
            {this.props.task.markChosen ? (
              <button
                id={this.state.markChosenButton}
                className="btn btn-muted btn-sm"
                data-toggle="tooltip"
                type="button"
                title={`${this.props.task.markChosen.buttonMessage}`}
                onClick={() => this.props.taskToggleChosenMark()}
              >
                <i
                  className={`fa ${
                    this.props.task.markChosen.marked
                      ? 'fa-bookmark'
                      : 'fa-bookmark-o'
                  }`}
                />
              </button>
            ) : null}
          </div>
        </div>
      </article>
    );
  }
}

TaskItem.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    taskDomain: PropTypes.string.isRequired,
    ownerId: PropTypes.number.isRequired,
    ownerUserName: PropTypes.string.isRequired,
    ownerAvatarPath: PropTypes.string.isRequired,
    totalCostExecution: PropTypes.string.isRequired,
    taskTypeDesc: PropTypes.string.isRequired,
    checkTypeDesc: PropTypes.string.isRequired,
    executorExecutionIntervalDesc: PropTypes.string.isRequired,
    timePerformDesc: PropTypes.string.isRequired,
    hasGeoTarget: PropTypes.bool.isRequired,
    hasTimeTarget: PropTypes.bool.isRequired,
    markHide: PropTypes.shape({
      marked: PropTypes.bool,
      buttonMessage: PropTypes.string
    }).isRequired,
    markChosen: PropTypes.shape({
      marked: PropTypes.bool,
      buttonMessage: PropTypes.string
    }).isRequired,
    taskCommentsStat: PropTypes.shape({
      dislikes: PropTypes.number.isRequired,
      likes: PropTypes.number.isRequired,
      neutral: PropTypes.number.isRequired
    }).isRequired,
    tasksExecsStat: PropTypes.shape({
      statuses: PropTypes.shape({}).isRequired
    }).isRequired,
    createdAt: PropTypes.string.isRequired
  }).isRequired,
  // reducerName: PropTypes.string.isRequired
  // CONNECT
  taskToggleChosenMark: PropTypes.func.isRequired,
  taskToggleHideMark: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch, props) => ({
  taskToggleChosenMark: () =>
    dispatch(
      sendTaskToggleChosenMarkFormRequest(
        'tasksModule.forms.taskToggleChosenMarkForm',
        props.task.id
      )
    ),
  taskToggleHideMark: () =>
    dispatch(
      sendTaskToggleHideMarkFormRequest(
        'tasksModule.forms.taskToggleHideMarkForm',
        props.task.id
      )
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TaskItem)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksList/TaskItem/TaskItem.js